export default "__VITE_ASSET__CeUCf3Qn__"